import React, { useState, useEffect, useContext, memo } from 'react';
import { useSelector } from 'react-redux';
import Input from '../../../CoreWrappers/Input';
import { SVGICONS } from '@ey/icons';
import styled from 'styled-components';
import { UserLookupType, DefautAddGroupRoles, AdminGroupRoles, UserType } from '../../../../util/uiconstants';
import { labels } from '../../../../util/utils';
import UserSearch from '../../../Common/Search/CustomizedUsersearch';
import { GroupContext } from './Helper/GroupContext';
import * as groupActiontypes from './Helper/GroupActionTypes';

const AddUser = (props) => {
	const [groupName, setGroupName] = useState('');
	const [showNameValidation, setShowNameValidation] = useState(false);
	const [showUserSeachValidations, setShowUserSeachValidations] = useState(0);
	const [userInformation, setUserInformation] = useState({});
	const [currentEmailAddress, setEmailAddress] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [isDuplicateUser, setIsDuplicateUser] = useState(false);
	const isMultiSelectMode = useSelector((store) => store.isMultiSelectMode);
	const { state, dispatch } = useContext(GroupContext);

	useEffect(() => {
		const thisUser = findSelectedUser();
		if (thisUser) {
			setFirstName(thisUser.firstName);
			setLastName(thisUser.lastName);
			setUserInformation(thisUser);
		}
		checkDuplicateUser();
	}, [state.users]);

	const findSelectedUser = () => {
		const thisUser = state.users.find((el) => el.id == props.id);

		return thisUser;
	};

	const cleanUser = (id, isEmpty) => {
		dispatch({ type: groupActiontypes.SET_USER_EMPTY, payload: { id: props.id, isEmpty: true } });
	};

	const checkDuplicateUser = () => {
		let found = false;

		if (currentEmailAddress !== '') {
			found = state.users.some((el) => el.emailAddress === currentEmailAddress && el.id !== props.id);
		}

		if (found) {
			setIsDuplicateUser(true);
		} else {
			setIsDuplicateUser(false);
		}
	};

	const onUserSelectionChange = (user) => {
		const { firstName, lastName, gui, userType, isInternal } = user.allProps;	
		checkDuplicateUser();
		setUserInformation(user.allProps);
		setFirstName(firstName);
		setLastName(lastName);
		setEmailAddress(user.value);
		setShowNameValidation(false);
		setSelectedMember(user);
	};

	const setSelectedMember = (user) => {
		const { gui, userType, isInternal, firstName, lastName} = user.allProps;		
		let payload = {};
		if (isMultiSelectMode) {
			payload = {
				id: props.id,
				firstName: firstName,
				lastName: lastName,
				emailAddress: user.value,
				roles: gui ? DefautAddGroupRoles : AdminGroupRoles,
				userId: gui ? gui : user.value,
				isInternal: isInternal || userType === UserType.Member,
				isEmpty: false
			};
		} else {
			payload = {
				id: gui ? gui : user.value,
				firstName: firstName,
				lastName: lastName,
				emailAddress: user.value,
				roles: gui ? DefautAddGroupRoles : AdminGroupRoles,
				userId: gui ? gui : user.value,
				isInternal: isInternal || userType === UserType.Member,
				isEmpty: false
			};
		}
		
		dispatch({ type: groupActiontypes.UPDATE_USERS, payload: payload });

		if (props.setSelectedMember) {
			props.setSelectedMember(payload);
		}
	}

	const resetInputValues = () => {
		setUserInformation({});
	};

	const onUserClear = () => {
		setFirstName('');
		setLastName('');
		resetInputValues();
	};

	useEffect(() => {
		if (props.clearData) {
			onUserClear();
		}
	}, [props.clearData]);

	return (
		<StyledAddUser className={props.className} id={props.id}>
			<section className="search-box-wrapper">
				<UserSearch
					// TODO: Add proper label
					key={props.id}
					id={props.id}
					showValidations={showUserSeachValidations}
					onUserClear={onUserClear}
					onUserSelectionChange={onUserSelectionChange}
					lookupType={props.userLookupType || UserLookupType.NotSpecified}
					userError={props.userError}
					isNewAdd={props.isNewAdd}
					maxSearchLength={100}
					user={{}}
					isDisabled={props.isDisabled}
					clearUserData={props.clearData}
					canClearSelectedValue={props.canClearSelectedValue}
					isDuplicateUser={props.isDuplicateUser || isDuplicateUser}
					duplicateUserMessage={props.duplicateUserMessage}
					hideClearIcon={props.hideClearIcon}
					findSelectedUser={findSelectedUser}
					cleanUser={cleanUser}
				/>
			</section>
			<div className="group-input-textbox">
				<Input
					label={labels.firstName}
					id={'firstname_' + props.id}
					maxLength="100"
					value={firstName}
					errorMessage={props.userError && !firstName ? labels.required : null}
					onChange={(e) => {
						setFirstName(e.target.value);
						var payload = {
							id: userInformation.gui ? userInformation.gui : userInformation.value,
							firstName: firstName,
							lastName: lastName,
							emailAddress: userInformation.email,
							roles: userInformation.gui ? DefautAddGroupRoles : AdminGroupRoles,
							userId: userInformation.gui ? userInformation.gui : userInformation.email,
							isInternal: userInformation.isInternal || userInformation.userType === UserType.Member,
							isEmpty: false
						};
						setUserInformation({...userInformation, firstName: e.target.value});
						props.setSelectedMember({...payload, firstName: e.target.value});
					}}
					disabled={!props.isNameEditable}
				/>
			</div>
			<div className="group-input-textbox">
				<Input
					label={labels.lastName}
					id={'lastname' + props.id}
					maxLength="100"
					value={lastName}
					errorMessage={props.userError && !lastName ? labels.required : null}
					onChange={(e) => {
						setLastName(e.target.value);
						var payload = {
							id: userInformation.gui ? userInformation.gui : userInformation.value,
							firstName: firstName,
							lastName: lastName,
							emailAddress: userInformation.email,
							roles: userInformation.gui ? DefautAddGroupRoles : AdminGroupRoles,
							userId: userInformation.gui ? userInformation.gui : userInformation.email,
							isInternal: userInformation.isInternal || userInformation.userType === UserType.Member,
							isEmpty: false
						};
						setUserInformation({...userInformation, lastName: e.target.value});
						props.setSelectedMember({...payload, lastName: e.target.value});
					}}
					disabled={!props.isNameEditable}
				/>
			</div>
			<span
				title={labels.clearAllValues}
				className="pull-left clearall"
				onClick={() => {
					props.remove(props.id);
					dispatch({type: groupActiontypes.REMOVE_USER, payload: {id: props.id}});
				}}
			>
				{props.hideRemoveIcon ? (
					<></>
				) : (
					<SVGICONS styleName="medium" name={'close'} id={props.id} hoverText={labels.remove} alt="Clear" />
				)}
			</span>
		</StyledAddUser>
	);
};

export const AddUserMemoized = memo(AddUser);

export default AddUserMemoized;

const StyledAddUser = styled.section`
	display: flex;
	justify-content: space-between;
	width: 100%;
	// background-color: ${(props) => props.theme.color[`white`]};
	margin: 2rem -1rem 3rem;
	min-height: 5rem;
	.user-selectbox {
		display: inline-block;
		width: 100%;
	}
	.search-box-wrapper {
		max-height: 5rem;
		padding-bottom: 1rem;
		width: 24rem;

		.enterdetail-description {
			bottom: 0;
			margin-top: 0.5rem;
			margin-left: 1rem;
		}
	}
	.search-box-wrapper,
	.group-input-textbox,
	.clearall {
		flex-grow: 1;
		margin: 0 0.5rem;
	}
	.clearall {
		margin-top: 1.3rem;
		svg{
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
	.group-input-textbox {
		width: 10rem;
		input {
			text-overflow: ellipsis;
			height: 5rem;
			&[disabled] {
				border: 0 !important;
				&::placeholder {
					color: ${(props) => props.theme.color[`white`]};
				}
			}
		}
		svg {
			&.small {
				width: 2rem;
				height: 2rem;
				max-width: 2rem;
				max-height: 2rem;
			}
		}

		.motif-disabled {
			&.motif-label-for-text {
				color: ${(props) => props.theme.color[`grey400`]} !important;
			}
		}
	}
	.motif-input-component {
		width: 100%;
	}

	.motif-input-component input:disabled{
		background: ${(props) => props.theme.color[`grey100grey450`]} !important;
	}
`;
